export default function AboutSection() {
  const features = [
    {
      icon: "ri-cpu-line",
      title: "Premium Components",
      desc: "Carefully sourced hardware from the world's leading manufacturers, ensuring quality you can count on.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Reliability First",
      desc: "Every product is tested and verified. We stand behind what we sell with comprehensive support.",
    },
    {
      icon: "ri-flashlight-line",
      title: "Cutting-Edge Tech",
      desc: "Stay ahead of the curve with the latest innovations in computing, networking, and embedded systems.",
    },
  ];

  return (
    <section id="about" className="relative py-28 px-4" style={{ background: "linear-gradient(180deg, #0a0e1a 0%, #0d1117 100%)" }}>
      {/* Decorative top line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-20 bg-gradient-to-b from-transparent to-cyan-500/40" />

      <div className="max-w-6xl mx-auto">
        {/* Section label */}
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="h-px w-12 bg-cyan-500/40" />
          <span className="text-cyan-400 text-xs font-mono tracking-widest uppercase">// About</span>
          <div className="h-px w-12 bg-cyan-500/40" />
        </div>

        {/* Heading */}
        <h2 className="text-3xl md:text-5xl font-black text-white text-center leading-tight mb-6">
          Building the Future of{" "}
          <span className="text-cyan-400">Hardware</span>
        </h2>

        <p className="text-gray-400 text-center max-w-2xl mx-auto text-base md:text-lg leading-relaxed mb-16">
          We&apos;re assembling a destination for engineers, builders, and tech enthusiasts who demand the best.
          SolidHardware.net will be your one-stop shop for components that perform — no compromises.
        </p>

        {/* Feature cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="group relative rounded-xl p-7 border border-white/5 hover:border-cyan-500/30 transition-all duration-300"
              style={{ background: "rgba(255,255,255,0.03)" }}
            >
              {/* Glow on hover */}
              <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{ background: "radial-gradient(circle at 50% 0%, rgba(100,200,255,0.06), transparent 70%)" }} />

              <div className="w-12 h-12 flex items-center justify-center rounded-lg mb-5 bg-cyan-500/10 border border-cyan-500/20">
                <i className={`${f.icon} text-cyan-400 text-xl`} />
              </div>
              <h3 className="text-white font-bold text-lg mb-3">{f.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        {/* Visual strip */}
        <div className="mt-16 rounded-2xl overflow-hidden border border-white/5 relative">
          <img
            src="https://public.readdy.ai/ai/img_res/2f8af1495a867d8265944d75fb37a111.jpg"
            alt="Hardware components"
            className="w-full h-48 md:h-64 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0d1117]/80 via-transparent to-[#0d1117]/80" />
          <div className="absolute inset-0 flex items-center justify-center">
            <p className="text-white/60 text-sm font-mono tracking-widest uppercase">Precision. Performance. Reliability.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
